// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"de9cb98f","750":"de9cb98f","1551":"de9cb98f","2560":"247567f4","3064":"757b01e8","4353":"68ee5680","5156":"7ca5b2fb","5351":"de9cb98f","8289":"fad13a90"}[chunkId] + ".chunk.css";
};